/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
	AddClientContact,
	BulkAddClientContact,
	BulkRemoveClientContact,
	ClientContactResponse,
	ClientContactWithDetails,
	ClientContactWithDetailsEnumeration,
	UpdateClientContact,
} from '../models/index';
import {
	AddClientContactFromJSON,
	AddClientContactToJSON,
	BulkAddClientContactFromJSON,
	BulkAddClientContactToJSON,
	BulkRemoveClientContactFromJSON,
	BulkRemoveClientContactToJSON,
	ClientContactResponseFromJSON,
	ClientContactResponseToJSON,
	ClientContactWithDetailsFromJSON,
	ClientContactWithDetailsToJSON,
	ClientContactWithDetailsEnumerationFromJSON,
	ClientContactWithDetailsEnumerationToJSON,
	UpdateClientContactFromJSON,
	UpdateClientContactToJSON,
} from '../models/index';

export interface AddClientContactRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
	addClientContact?: AddClientContact;
}

export interface BulkAddClientContactsRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
	bulkAddClientContact?: BulkAddClientContact;
}

export interface BulkRemoveClientContactsRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
	bulkRemoveClientContact?: BulkRemoveClientContact;
}

export interface GetClientContactRequest {
	encodedClientRID: string;
	encodedActorRID: string;
	xBffCsrf?: string;
}

export interface GetClientContactsRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
}

export interface RemoveClientContactRequest {
	encodedClientRID: string;
	encodedActorRID: string;
	xBffCsrf?: string;
}

export interface UpdateClientContactRequest {
	encodedClientRID: string;
	encodedActorRID: string;
	xBffCsrf?: string;
	updateClientContact?: UpdateClientContact;
}

/**
 * ClientContactsApi - interface
 *
 * @export
 * @interface ClientContactsApiInterface
 */
export interface ClientContactsApiInterface {
	/**
	 * Endpoint adds client contact to a client organization. Requires client_clientcontact:create permission.
	 * @summary Add client contact
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {AddClientContact} [addClientContact] Payload to add a user to a client organization
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientContactsApiInterface
	 */
	addClientContactRaw(
		requestParameters: AddClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientContactWithDetails>>;

	/**
	 * Endpoint adds client contact to a client organization. Requires client_clientcontact:create permission.
	 * Add client contact
	 */
	addClientContact(
		requestParameters: AddClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientContactWithDetails>;

	/**
	 * Endpoint adds multiple client contacts to a client organization. If the client contact does not have actorRID then it will try to fetch the user with email, otherwise create a new user in v3. Requires client_clientcontact:create permission.
	 * @summary Add multiple client contacts
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {BulkAddClientContact} [bulkAddClientContact] Payload to add multiple users to a client organization
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientContactsApiInterface
	 */
	bulkAddClientContactsRaw(
		requestParameters: BulkAddClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientContactWithDetailsEnumeration>>;

	/**
	 * Endpoint adds multiple client contacts to a client organization. If the client contact does not have actorRID then it will try to fetch the user with email, otherwise create a new user in v3. Requires client_clientcontact:create permission.
	 * Add multiple client contacts
	 */
	bulkAddClientContacts(
		requestParameters: BulkAddClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientContactWithDetailsEnumeration>;

	/**
	 * Endpoint removes multiple client contacts from a client organization using the provided list of actor RIDs. Requires client_clientcontact:delete permission.
	 * @summary Remove multiple client contacts
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {BulkRemoveClientContact} [bulkRemoveClientContact] Payload to remove multiple users from a client organization using the provided list of actor RIDs
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientContactsApiInterface
	 */
	bulkRemoveClientContactsRaw(
		requestParameters: BulkRemoveClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint removes multiple client contacts from a client organization using the provided list of actor RIDs. Requires client_clientcontact:delete permission.
	 * Remove multiple client contacts
	 */
	bulkRemoveClientContacts(
		requestParameters: BulkRemoveClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Get a client contact by the client entity RID and actor RID. Requires client_clientcontact:read permission.
	 * @summary Get client contact
	 * @param {string} encodedClientRID
	 * @param {string} encodedActorRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientContactsApiInterface
	 */
	getClientContactRaw(
		requestParameters: GetClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientContactResponse>>;

	/**
	 * Get a client contact by the client entity RID and actor RID. Requires client_clientcontact:read permission.
	 * Get client contact
	 */
	getClientContact(
		requestParameters: GetClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientContactResponse>;

	/**
	 * Endpoint gets client contacts for a client organization. Requires client_clientcontact:read permission.
	 * @summary List client contacts
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientContactsApiInterface
	 */
	getClientContactsRaw(
		requestParameters: GetClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientContactWithDetailsEnumeration>>;

	/**
	 * Endpoint gets client contacts for a client organization. Requires client_clientcontact:read permission.
	 * List client contacts
	 */
	getClientContacts(
		requestParameters: GetClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientContactWithDetailsEnumeration>;

	/**
	 * Remove a client contact from a client organization. Requires client_clientcontact:delete permission.
	 * @summary Remove a client contact
	 * @param {string} encodedClientRID
	 * @param {string} encodedActorRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientContactsApiInterface
	 */
	removeClientContactRaw(
		requestParameters: RemoveClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Remove a client contact from a client organization. Requires client_clientcontact:delete permission.
	 * Remove a client contact
	 */
	removeClientContact(
		requestParameters: RemoveClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Update the client contact in a client organization. Requires client_clientcontact:modify permission.
	 * @summary Update client contact
	 * @param {string} encodedClientRID
	 * @param {string} encodedActorRID
	 * @param {string} [xBffCsrf]
	 * @param {UpdateClientContact} [updateClientContact] Payload to update the client contact in a client organization
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientContactsApiInterface
	 */
	updateClientContactRaw(
		requestParameters: UpdateClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Update the client contact in a client organization. Requires client_clientcontact:modify permission.
	 * Update client contact
	 */
	updateClientContact(
		requestParameters: UpdateClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;
}

/**
 *
 */
export class ClientContactsApi
	extends runtime.BaseAPI
	implements ClientContactsApiInterface
{
	/**
	 * Endpoint adds client contact to a client organization. Requires client_clientcontact:create permission.
	 * Add client contact
	 */
	async addClientContactRaw(
		requestParameters: AddClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientContactWithDetails>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling addClientContact.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/clientContacts`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: AddClientContactToJSON(requestParameters.addClientContact),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientContactWithDetailsFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint adds client contact to a client organization. Requires client_clientcontact:create permission.
	 * Add client contact
	 */
	async addClientContact(
		requestParameters: AddClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientContactWithDetails> {
		const response = await this.addClientContactRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint adds multiple client contacts to a client organization. If the client contact does not have actorRID then it will try to fetch the user with email, otherwise create a new user in v3. Requires client_clientcontact:create permission.
	 * Add multiple client contacts
	 */
	async bulkAddClientContactsRaw(
		requestParameters: BulkAddClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientContactWithDetailsEnumeration>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling bulkAddClientContacts.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/bulkClientContacts`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: BulkAddClientContactToJSON(requestParameters.bulkAddClientContact),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientContactWithDetailsEnumerationFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint adds multiple client contacts to a client organization. If the client contact does not have actorRID then it will try to fetch the user with email, otherwise create a new user in v3. Requires client_clientcontact:create permission.
	 * Add multiple client contacts
	 */
	async bulkAddClientContacts(
		requestParameters: BulkAddClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientContactWithDetailsEnumeration> {
		const response = await this.bulkAddClientContactsRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 * Endpoint removes multiple client contacts from a client organization using the provided list of actor RIDs. Requires client_clientcontact:delete permission.
	 * Remove multiple client contacts
	 */
	async bulkRemoveClientContactsRaw(
		requestParameters: BulkRemoveClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling bulkRemoveClientContacts.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/bulkClientContacts`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
				body: BulkRemoveClientContactToJSON(requestParameters.bulkRemoveClientContact),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint removes multiple client contacts from a client organization using the provided list of actor RIDs. Requires client_clientcontact:delete permission.
	 * Remove multiple client contacts
	 */
	async bulkRemoveClientContacts(
		requestParameters: BulkRemoveClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.bulkRemoveClientContactsRaw(requestParameters, initOverrides);
	}

	/**
	 * Get a client contact by the client entity RID and actor RID. Requires client_clientcontact:read permission.
	 * Get client contact
	 */
	async getClientContactRaw(
		requestParameters: GetClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientContactResponse>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling getClientContact.'
			);
		}

		if (
			requestParameters.encodedActorRID === null ||
			requestParameters.encodedActorRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedActorRID',
				'Required parameter requestParameters.encodedActorRID was null or undefined when calling getClientContact.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/clientContacts/{encodedActorRID}`
					.replace(
						`{${'encodedClientRID'}}`,
						encodeURIComponent(String(requestParameters.encodedClientRID))
					)
					.replace(
						`{${'encodedActorRID'}}`,
						encodeURIComponent(String(requestParameters.encodedActorRID))
					),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientContactResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Get a client contact by the client entity RID and actor RID. Requires client_clientcontact:read permission.
	 * Get client contact
	 */
	async getClientContact(
		requestParameters: GetClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientContactResponse> {
		const response = await this.getClientContactRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint gets client contacts for a client organization. Requires client_clientcontact:read permission.
	 * List client contacts
	 */
	async getClientContactsRaw(
		requestParameters: GetClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientContactWithDetailsEnumeration>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling getClientContacts.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/clientContacts`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientContactWithDetailsEnumerationFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint gets client contacts for a client organization. Requires client_clientcontact:read permission.
	 * List client contacts
	 */
	async getClientContacts(
		requestParameters: GetClientContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientContactWithDetailsEnumeration> {
		const response = await this.getClientContactsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Remove a client contact from a client organization. Requires client_clientcontact:delete permission.
	 * Remove a client contact
	 */
	async removeClientContactRaw(
		requestParameters: RemoveClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling removeClientContact.'
			);
		}

		if (
			requestParameters.encodedActorRID === null ||
			requestParameters.encodedActorRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedActorRID',
				'Required parameter requestParameters.encodedActorRID was null or undefined when calling removeClientContact.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/clientContacts/{encodedActorRID}`
					.replace(
						`{${'encodedClientRID'}}`,
						encodeURIComponent(String(requestParameters.encodedClientRID))
					)
					.replace(
						`{${'encodedActorRID'}}`,
						encodeURIComponent(String(requestParameters.encodedActorRID))
					),
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Remove a client contact from a client organization. Requires client_clientcontact:delete permission.
	 * Remove a client contact
	 */
	async removeClientContact(
		requestParameters: RemoveClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.removeClientContactRaw(requestParameters, initOverrides);
	}

	/**
	 * Update the client contact in a client organization. Requires client_clientcontact:modify permission.
	 * Update client contact
	 */
	async updateClientContactRaw(
		requestParameters: UpdateClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling updateClientContact.'
			);
		}

		if (
			requestParameters.encodedActorRID === null ||
			requestParameters.encodedActorRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedActorRID',
				'Required parameter requestParameters.encodedActorRID was null or undefined when calling updateClientContact.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/clientContacts/{encodedActorRID}`
					.replace(
						`{${'encodedClientRID'}}`,
						encodeURIComponent(String(requestParameters.encodedClientRID))
					)
					.replace(
						`{${'encodedActorRID'}}`,
						encodeURIComponent(String(requestParameters.encodedActorRID))
					),
				method: 'PUT',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateClientContactToJSON(requestParameters.updateClientContact),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Update the client contact in a client organization. Requires client_clientcontact:modify permission.
	 * Update client contact
	 */
	async updateClientContact(
		requestParameters: UpdateClientContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.updateClientContactRaw(requestParameters, initOverrides);
	}
}
